import { ApiV1Job, JobStatus, JobTriggerShortInfo } from '@app/Models/WebApiModels';

export class JobStatusMessage {
    name: string;
    triggerId: string;
    status: JobStatus;
    lastErrorMessage?: string;
    progressMessage?: string;
    jobExecutionInfo?: JobExecutionInfo;
    timestampDateTimeUtc: Date;
}

export class JobExecutionInfo {
    lastRunDateTimeUtc?: Date;
    nextRunDateTimeUtc?: Date;
    lastRunTriggerName: string | null;
    nextRunTriggerName: string | null;
    lastInfoMessage: string | null;
}

export class JobProgressMaxValue {
    triggerId: string;
    maxValue: number;
}

export class JobProgressValue {
    triggerId: string;
    value: number;
    maxValue: number;
}

export type TriggerExtended = JobTriggerShortInfo & {
    isManual?: boolean;
    progressMax?: number;
    progressCurrent?: number;
    currentMessage?: string;
};

export const isTriggerFailed = (trigger: JobTriggerShortInfo) => trigger.status === JobStatus.Fail || !!trigger.scheduleError;

export const isJobFailed = (job: ApiV1Job) => job.lastStatus === JobStatus.Fail || !!job.triggers?.some(isTriggerFailed);

export const getJobErrorMessage = (job: ApiV1Job) => {
    const failedSchedules = (job.triggers ?? []).filter(t => !!t.scheduleError);
    let errorMessage = job.lastErrorMessage || '';
    if (failedSchedules.length) {
        if (errorMessage) {
            errorMessage += '. ';
        }
        errorMessage += failedSchedules.map(t => t.scheduleError).join(', \n');
    }
    return errorMessage;
};
